import React, { memo } from 'react';
import { AuthHeader } from 'src/common/components/AuthHeader';
import { AuthHeaderItem } from 'src/common/components/AuthHeaderItem';

export const CompanyConfirmationHeader = memo(() => (
  <AuthHeader>
    <AuthHeaderItem active={true}>Aktualizacja danych</AuthHeaderItem>
  </AuthHeader>
));
